import React from "react";
import { useTranslation } from "react-i18next";
import { Info } from "lucide-react";
import { fmtDateTime } from "../../lib/format";
import PlatformLifecycleBadge from "./PlatformLifecycleBadge";

const Row = ({ label, value, testId }) => (
  <div className="qw-life-row">
    <span className="qw-life-label">{label}</span>
    <span data-testid={testId}>{value}</span>
  </div>
);

/**
 * The lifecycle facts of one organization, READ ONLY.
 *
 * The timestamps are shown because a platform administrator must be able to see
 * WHY an organization is blocked. Every destructive action lives in its own
 * component (`PlatformLifecycleActions`), never here.
 */
export const PlatformLifecycleCard = ({ organization, lifecycle }) => {
  const { t } = useTranslation();
  const state = lifecycle || {};

  return (
    <div className="qw-card" data-testid="platform-lifecycle-card">
      <div className="hstack" style={{ justifyContent: "space-between", marginBottom: 12 }}>
        <div style={{ fontWeight: 600 }}>{t("platform.lifecycle_section")}</div>
        <PlatformLifecycleBadge status={state.status} testId="platform-lifecycle-badge" />
      </div>

      <div className="qw-life-grid">
        <Row
          label={t("platform.created_at")}
          value={fmtDateTime(organization?.created_at)}
          testId="platform-lifecycle-created-at"
        />
        <Row
          label={t("platform.activated_at")}
          value={fmtDateTime(state.activated_at)}
          testId="platform-lifecycle-activated-at"
        />
        <Row
          label={t("platform.archived_at")}
          value={fmtDateTime(state.archived_at)}
          testId="platform-lifecycle-archived-at"
        />
        <Row
          label={t("platform.deletion_requested_at")}
          value={fmtDateTime(state.deletion_requested_at)}
          testId="platform-lifecycle-deletion-requested-at"
        />
        <Row
          label={t("platform.delete_after")}
          value={fmtDateTime(state.delete_after)}
          testId="platform-lifecycle-delete-after"
        />
      </div>

      {state.blocks_tenant_access && (
        <div className="qw-help" style={{ marginTop: 10 }} data-testid="platform-lifecycle-blocked">
          <Info size={13} strokeWidth={2} aria-hidden="true" /> {t("platform.blocks_tenant_access")}
        </div>
      )}
    </div>
  );
};

export default PlatformLifecycleCard;
